<div
  class="xi-modal__container"
  *transloco="let t; read: 'dashboard-page-reorder-dialog-component'"
>
  <h2 class="xi-modal__title">{{ t('title') }}</h2>

  <h5 class="page-reorder-subtitle">{{ t('header') }}</h5>

  <div class="xi-modal__content">
    <mat-list cdkDropList (cdkDropListDropped)="onItemsReordered($event)" class="sort-item-list">
      @for (item of sortOrder; track item) {
        <mat-list-item cdkDrag cdkDragPreviewContainer="parent" class="sort-item">
          <xi-icon cdkDragHandle icon="drag_handle"></xi-icon>
          {{ item.title }}
        </mat-list-item>
      }
    </mat-list>
  </div>

  <div class="xi-modal__actions">
    <xi-default-button
      text="{{ t('cancel') }}"
      fill="text"
      (onClick)="cancel()"
    ></xi-default-button>
    <xi-default-button text="{{ t('save') }}" (onClick)="save()"></xi-default-button>
  </div>
</div>
